import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddlePatientMetricsHaveData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { DashboardMetricItemData } from '../../../../../types/dashboardMetrics.types'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type PatientsCardProps = {
  titleHref: string
  metrics: DashboardMetricItemData[]
  loading: boolean
  data: DashboardMetricItemData[] | null
}

export function PatientsCard({
  titleHref,
  metrics,
  loading,
  data,
}: PatientsCardProps): React.ReactElement {
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddlePatientMetricsHaveData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Patients"
      titleHref={titleHref}
      className="dashboard-huddle-patients-card"
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={metrics} />
    </DashboardSectionCard>
  )
}
